import { useMemo } from 'react';
import { ROUTERS } from 'components/modules/shipper/RoutingConfiguration';
export const useDistance = ({ distance, routeConfiguration, }) => {
    return useMemo(() => {
        const type = routeConfiguration === null || routeConfiguration === void 0 ? void 0 : routeConfiguration.routing_type;
        const version = routeConfiguration === null || routeConfiguration === void 0 ? void 0 : routeConfiguration.routing_configuration;
        const isPcMiler = Boolean(version && type === ROUTERS.PC_MILER.value);
        const routerName = isPcMiler ? type : type || ROUTERS.GOOGLE_MILES.name;
        return {
            hasDistance: Boolean(distance),
            distance,
            routeConfiguration,
            isPcMiler,
            routerName,
        };
    }, [distance, routeConfiguration]);
};
